export const SAVE_SIGNATURE = 'App/Contract::SAVE_SIGNATURE';
export const CONFIRM_CONTRACT = 'App/Contract::CONFIRM_CONTRACT';
export const CONFIRMED_CONTRACT = 'App/Contract::CONFIRMED_CONTRACT';
export const SAVE_PHOTO = 'App/Contract::SAVE_PHOTO';
